import api from '../api/axios'
import { UserResponse } from '../types/auth'
import { EstadoIntegraciones, PermisosPuente, PersonaPuente, ResumenFactos, UsuarioDev } from '../types/integracion'

export const integracionService = {
  estado: async (): Promise<EstadoIntegraciones> => (await api.get<EstadoIntegraciones>('integraciones/')).data,

  permisosPuente: async (): Promise<PermisosPuente> => (await api.get<PermisosPuente>('integraciones/puente/permisos/')).data,

  personaPuente: async (rut: number): Promise<PersonaPuente> =>
    (await api.get<PersonaPuente>(`integraciones/puente/personas/${rut}/`)).data,

  resumenFactos: async (): Promise<ResumenFactos> => (await api.get<ResumenFactos>('integraciones/factos/personas/')).data,
  /** Da cuenta (sin roles) a quienes trabajan en el DCC según Factos. */
  importarFactos: async (): Promise<ResumenFactos> => (await api.post<ResumenFactos>('integraciones/factos/personas/', {})).data,
}

/** Solo desarrollo (DEV_LOGIN_ENABLED): responde 404 en producción. */
export const devService = {
  usuarios: async (q = ''): Promise<UsuarioDev[]> =>
    (await api.get<{ usuarios: UsuarioDev[] }>('dev/usuarios/', { params: { q } })).data.usuarios,

  entrarComo: async (datos: { username: string } | { admin: true }): Promise<UserResponse> =>
    (await api.post<UserResponse>('dev/login-as/', datos)).data,
}
